// extracted by mini-css-extract-plugin
export var cardContainer = "_oq-0";
export var cardHeader = "_oq-2";
export var collapsedState = "_oq-3";
export var dragHandle = "_oq-5";
export var dragHandleIcon = "_oq-6";
export var dragging = "_oq-1";
export var titleArea = "_oq-4";